import { render, staticRenderFns } from "./BtnConferir.vue?vue&type=template&id=33f99493&"
import script from "./BtnConferir.vue?vue&type=script&lang=js&"
export * from "./BtnConferir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports